import { SortOrder } from 'app/area/favourite/types';
import { FavouriteDefinition, DefaultSortOrder } from 'app/types-shared';

function mapSortOrder(defaultSortOrder: DefaultSortOrder[]): SortOrder[] {
  return defaultSortOrder.map(item => ({
    domainNode: {
      v: item.domainNode.value,
      d: item.domainNode.description
    },
    sortOrderType: item.sortOrderType,
    sequence: item.orderBySequence
  }));
}

export const updateDefinitionWithSort = (report: number, sortOrderFields: DefaultSortOrder[]) =>
  (definition: FavouriteDefinition): FavouriteDefinition => {

    return {
      ...definition,
      reports:
        (definition.reports || []).map(r => r.report.v === report
          ? {
            ...r,
            sort: mapSortOrder(sortOrderFields)
          }
          : r
        )
    };
  };
